import React from "react";
import { Button, Image } from "react-bootstrap";
import { Field, FieldArray, useFormikContext } from "formik";
import { usDateFormat, errors, getNullTableItem } from "../../../../../utils";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  FieldInputDecimal,
  FieldInputDollar,
} from "../../../../../components";
import history from "../../../../../mocks/investmentHistory.json";
import ExcelImage from "../../../../../styles/exportimg.PNG";

const columns = [
  {
    label: "Date",
    className: "column-investment-date",
    columnName: "investmentDate",
  },
  {
    label: "Investment Price",
    className: "column-investment-price",
    columnName: "investmentPrice",
  },
  {
    label: "Accrual Factor",
    className: "column-investment-accural-factor",
    columnName: "investmentAccuralFactor",
  },
];

const History = ({ fields, isEdit, isSave, precision }) => {
  const {
    values,
    handleChange,
    setFieldValue,
    setFieldError,
  } = useFormikContext();
  const fieldArrayName = "investmentHistory";

  const onSubmit = () => {
    if (
      Date.parse(values[fields.fromDate]) > Date.parse(values[fields.toDate])
    ) {
      setFieldError(
        fields.toDate,
        errors.historyFilterDateOverlap.overlapError
      );
    } else {
    }
  };

  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  return (
    <>
      <div className="d-flex" style={{ justifyContent: "space-between" }}>
        <h5 className="mb-2">Investment Price / Accrual History </h5>
        <Button
          className="export-button"
          title="Export Excel"
          variant="secondary"
          style={{ border: "none" }}
        >
          <Image src={ExcelImage} width="20px" />
          Export
        </Button>
      </div>
      <div className="d-flex">
        <div className="mr-4">
          <Field
            size="sm"
            isRequired
            autoComplete="off"
            label="Date range"
            name={fields.fromDate}
            value={usDateFormat(values[fields.fromDate])}
            isDatePicker
            placeholder="From date"
            direction="bottom"
            onClear={() => onDaySelected(fields.fromDate, "")}
            popupContent={
              <DatePicker
                onDayClick={(value) => onDaySelected(fields.fromDate, value)}
                value={usDateFormat(values[fields.fromDate])}
              />
            }
            component={FieldDropSide}
          />
        </div>
        <div className="mr-4">
          <Field
            size="sm"
            label=""
            name={fields.toDate}
            isRequired
            autoComplete="off"
            placeholder="To date"
            value={usDateFormat(values[fields.toDate])}
            direction="bottom"
            isDatePicker
            onClear={() => {
              onDaySelected(fields.toDate, "");
            }}
            onDefaultClearDisplay={values[fields.toDate]}
            popupContent={
              <DatePicker
                onDayClick={(value) => onDaySelected(fields.toDate, value)}
                value={usDateFormat(values[fields.toDate])}
              />
            }
            component={FieldDropSide}
          />
        </div>
        <div className="mt-15 mr-4">
          <Button
            className="mt-16 sort-button"
            style={{ lineHeight: "19px" }}
            variant="secondary"
            onClick={() => onSubmit()}
          >
            Search
          </Button>
        </div>
      </div>
      <FieldArray name={fieldArrayName}>
        {() => {
          return (
            <>
              {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
              <Table className="investment-history-table">
                <Table.Thead>
                  <Table.Tr>
                    {columns.map((item, index) => {
                      return (
                        <Table.Th key={index} className={item.className}>
                          {item.label}
                        </Table.Th>
                      );
                    })}
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {history.map((investmentItem, index) => {
                    return (
                      <Table.Tr key={index}>
                        {columns.map((item, cellIndex) => {
                          const getContent = () => {
                            const fieldName = `${fieldArrayName}[${index}].${item.columnName}`;
                            if (item.columnName === "investmentDate") {
                              return (
                                <div className="display-block">
                                  {usDateFormat(investmentItem.investmentDate)}
                                </div>
                              );
                            }
                            if (item.columnName === "investmentPrice") {
                              return (
                                <span>
                                  <div>
                                    <Field
                                      name={fieldName}
                                      isRequired
                                      autoComplete="off"
                                      preventNegative
                                      disabled={isEdit && !isSave}
                                      min={0}
                                      max={9999999.99}
                                      precision={precision}
                                      onChange={handleChange}
                                      component={FieldInputDollar}
                                    />
                                  </div>
                                </span>
                              );
                            }
                            if (item.columnName === "investmentAccuralFactor") {
                              return (
                                <div>
                                  <Field
                                    name={fieldName}
                                    isRequired
                                    autoComplete="off"
                                    disabled={isEdit && !isSave}
                                    preventNegative
                                    min={0}
                                    max={9999999.99}
                                    onChange={handleChange}
                                    component={FieldInputDecimal}
                                  />
                                </div>
                              );
                            }
                            return investmentItem[item.columnName];
                          };
                          return (
                            <Table.Td
                              key={cellIndex}
                              className={item.className}
                            >
                              {getNullTableItem(getContent())}
                            </Table.Td>
                          );
                        })}
                      </Table.Tr>
                    );
                  })}
                </Table.Tbody>
              </Table>
            </>
          );
        }}
      </FieldArray>
    </>
  );
};

export default History;
